import { render, staticRenderFns } from "./kpiTable.vue?vue&type=template&id=55ba9fc9&"
import script from "./kpiTable.vue?vue&type=script&lang=js&"
export * from "./kpiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports